import { commentsData } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          {commentsData.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {commentsData.items.map((item, i) => (
            <div
              key={i}
              className={`p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/60 ${
                i === 0 ? 'md:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-sm font-medium text-secondary-700 flex-shrink-0">
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
                <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{item.platform}</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}